/**
 * **Centaurus**
 */
const factory = function factory({ window, thn }) {
    const refreshSite = thn.debounce(thn.siteCheck, 500);
    return {
        getId() {
            return '10036';
        },
        check() {
            return !!window.location.href.match(/maison/) || !!(window.location.hostname.match(/namastay/) && thn.data.media.name === 'mobile');
        },
        getSiteId() {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const hotelId = thn.dataLayerHelper.get('hotelCode') || window.hotel_ref || '';
            const isIframeOpen = !!(document.querySelector('main div > div')?.classList?.contains('opacity-100'));
            const isNamastay = window.location.hostname.match(/namastay/);
            if (thn.data.media.name === 'mobile') {
                return {
                    externalId: (!isIframeOpen && isNamastay) ? '' : `${hotelId}-m`,
                };
            }
            return {
                externalId: hotelId,
            };
        },
        boot() {
            if (document.body) {
                thn.observeDom(document.body, refreshSite, {
                    childList: true,
                    subtree: false,
                    attributes: false,
                });
            }
        },
        shutdown() {
            if (document.body) {
                refreshSite.cancel();
                thn.stopObserveDom(document.body, refreshSite);
            }
        },
    };
};

export { factory };
